/** Portal API bases (schema doc 9.3, 9.7). Every portal read and write starts with its prefix. */
import type { FlowPartnerKind } from "../types.ts";

export const PORTAL_API_BASE: Readonly<Record<FlowPartnerKind, string>> = {
  printer: "/printer-portal",
  fc: "/fc-portal",
  warehouse: "/warehouse-portal",
};

export function portalSessionPath(partner: FlowPartnerKind): string {
  return `${PORTAL_API_BASE[partner]}/me`;
}
